<script lang="ts">
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	// Services and configs
	import { devices_config } from 'src/configs/devices';
	// Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_control_component_channel_structure,
		is_gen_2,
		real_id,
	} from 'src/helpers/interface_helpers';
	// Components
	import TimerRemaining from 'src/components/TimerRemaining/TimerRemaining.svelte';
	import { beforeUpdate } from 'svelte';

	import type { Device } from 'src/types/Device';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import {
		createGen1StatusLabels,
		getGen1DeviceStatuses,
		createGen1CombinedLabelList,
	} from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	export let device: Device;

	let timerLabels: Record<string, any> = {};
	let timer = false;

	$: isGen2 = is_gen_2(device);

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);

	beforeUpdate(async () => {
		if (status?.online && deviceConfig) {
			timer =
				isGen2 && status?.[`${get_gen_2_component_channel_structure(device)}`]?.timer_started_at;
		}
	});
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		{#if timer}
			{#key status[get_gen_2_control_component_channel_structure(device)].timer_started_at}
				<TimerRemaining timerKey="gen2_main" {device} {status} {settings} bind:timerLabels />
			{/key}
		{/if}
		<DeviceLabelList labelList={combinedLabelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
</DeviceViewStateWrapper>
